import { Component, OnInit } from '@angular/core';
import {FieldConfig} from "@biletix/core/models/base/field-config.model";
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'btx-hes-code-input',
  templateUrl:'./btx-hes-code-input.component.html',
  styleUrls: ['./btx-hes-code-input.component.scss'],
  standalone: false
})
export class BtxHesCodeInputComponent implements OnInit {

  field: FieldConfig | any;

  group: FormGroup | any;

  hesCodeMask:string="AAAA - AAA - 00";

  constructor() { }

  ngOnInit(): void {
  }

}
